module.exports = __webpack_public_path__ + "img/close_white.3094c3d6.svg";